import { FC, useCallback, useState } from 'react'

import Cropper, { Area } from 'react-easy-crop'

import { PixelCrop, getCroppedImg } from './utilities/crop'

import { useToast } from 'shared/hooks'

import { Button, Slider, Modal } from 'components'

import styles from './styles.module.scss'

export interface AvatarChangerModalProps {
  isVisible: boolean
  onSave(image: Blob | MediaSource): void
  onClose(): void
  avatarUrl: string
}

export const AvatarChangerModal: FC<AvatarChangerModalProps> = (props) => {
  const { isVisible, onSave, onClose, avatarUrl } = props
  const [crop, setCrop] = useState({ x: 0, y: 0 })
  const [zoom, setZoom] = useState(1)
  const [croppedAreaPixels, setCroppedAreaPixels] = useState<PixelCrop>({
    height: 0,
    width: 0,
    x: 0,
    y: 0,
  })

  const { addToast } = useToast()

  const onCropComplete = useCallback(
    (_croppedArea: Area, croppedAreaPixels: Area) => {
      setCroppedAreaPixels(croppedAreaPixels)
    },
    [],
  )

  const handleCropImage = useCallback(async () => {
    try {
      const croppedImage = await getCroppedImg(avatarUrl, croppedAreaPixels)
      onSave(croppedImage)
    } catch (e) {
      addToast({
        message: 'Erro ao alterar a foto do perfil. Tente novamente.',
        type: 'alert',
      })
    }
  }, [avatarUrl, croppedAreaPixels, onSave])

  return (
    <>
      <Modal.Root
        isOpen={isVisible}
        onClose={() => {
          onClose()
          setZoom(1)
        }}
      >
        <Modal.Content size="sm" className={styles.avatarChargerModal}>
          <Modal.Title className={styles.title}>Foto do perfil</Modal.Title>
          <div className={styles.modalContent}>
            <div className={styles.imageCropper}>
              <Cropper
                image={avatarUrl}
                crop={crop}
                aspect={1}
                onCropChange={setCrop}
                onCropComplete={onCropComplete}
                cropSize={{ width: 260, height: 260 }}
                zoom={zoom}
                zoomWithScroll={false}
                onZoomChange={setZoom}
                cropShape="round"
                classes={{
                  containerClassName: styles.cropAreaContainer,
                  cropAreaClassName: styles.cropArea,
                }}
              />
            </div>

            <div className={styles.sliderContainer}>
              <Slider
                value={zoom}
                setValue={setZoom}
                inputMinValue={1}
                inputMaxValue={25}
              />
            </div>
          </div>

          <Modal.Footer className={styles.footer}>
            <Button
              appearance="tertiary"
              onClick={() => {
                onClose()
                setZoom(1)
              }}
            >
              Cancelar
            </Button>

            <Button width={95} appearance="primary" onClick={handleCropImage}>
              Salvar
            </Button>
          </Modal.Footer>
        </Modal.Content>
      </Modal.Root>
    </>
  )
}

export default AvatarChangerModal
